import styled from 'styled-components'

interface IFileViewerPreviewSectionStyledProps {}

export const FileViewerPreviewSectionStyled = styled.div<IFileViewerPreviewSectionStyledProps>`
  grid-area: preview;
`
